<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Review Details
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form>
          <div class="progress-linear-style">
            <p
              class="title-text-style"
            >
              Project Progress:
            </p>
            <v-progress-linear
              v-model="updatedProjectProgress"
              height="40"
              light
              color="#BDBDBD"
              rounded
            >
              <strong>{{ Math.ceil(updatedProjectProgress) }}%</strong>
            </v-progress-linear>
          </div>
          <br>
          <p
            class="title-text-style"
          >
            Check-out Gate: <font
              v-if="locationName.name !== undefined"
              class="value-text-style"
            >
              {{ locationName.name }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Work Clock:
            <check-in-clock style="color:#FF3700; font-size:16px;" />
          </p>
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="checkOut()"
    >
      Check-out
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  import moment from 'moment';
  import CheckInClock from 'src/views/dashboard/Components/CheckInClock.vue';

  export default {
    name: 'ReviewStaffCheckoutDetails',
    components: {
      'centre-spinner': spinner,
      'check-in-clock': CheckInClock,
    },
    data: () => ({
      loading: false,
      updatedProjectProgress: 0,
    }),
    computed: {
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      manualCheckoutDetails () {
        return this.$store.getters['swiftuser/getManualCheckoutDetails'];
      },
      projectProgress () {
        return this.$store.getters['swiftuser/getProjectProgress'];
      },
    },
    mounted () {
      this.loading = true;
      setTimeout(() => {
        this.updatedProjectProgress = this.projectProgress;
        this.loading = false;
      }, 1000);
    },
    methods: {
      convertToGmt (date) {
        return moment(date).utc();
      },
      checkOut () {
        this.loading = true;
        const siteId = this.$route.params.siteId;
        if (this.checkOutMethodType === 'manual-offsite') {
          this.$store.dispatch('swiftuser/checkOutUser', {
            checkOutTime: {
              checkout_time: this.convertToGmt(this.manualCheckoutDetails.checkOutTime),
              type: this.checkOutMethodType,
              manual_checkout_reason: this.manualCheckoutDetails.reason,
              checkout_gate: null,
              latitude: null,
              longitude: null,
            },
            checkInId: this.activeCheckInDetails.id,
          }).then(response => {
            this.completeCheckOutProcess();
          }).catch(errors => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('swiftuser/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: this.checkOutMethodType,
              manual_checkout_reason: null,
              checkout_gate: siteId,
              latitude: null,
              longitude: null,
            },
            checkInId: this.activeCheckInDetails.id,
          }).then(response => {
            this.completeCheckOutProcess();
          }).catch(errors => {
            this.loading = false;
          });
        }
      },
      async completeCheckOutProcess () {
        await this.$store.dispatch('swiftuser/sendProjectProgress', {
          projectProgress: {
            project_progress: this.projectProgress.toString(),
          },
          checkInId: this.activeCheckInDetails.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-out completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          localStorage.removeItem('checkInTime');
          localStorage.removeItem('checkIn');
          this.$emit('checkout-completed');
        }).catch(() => {
          this.loading = false;
        });
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
      },
    },
  };
</script>
